<template>
    <BRow class="bg-light pt-3">
        <BCol class="" md="1">
            <BFormSelect
                :options="limit_options"
                :value="limit"
                @input="change_rowsPerPage"
            >
            </BFormSelect>
        </BCol>
        <BCol class="" md="5">
            <span class="align-middle"
                >Showing {{ showingFrom }} - {{ showingTo }} of
                {{ totalItems }}</span
            >
        </BCol>
        <BCol md="6">
            <BPagination
                :per-page="limit"
                :total-rows="totalItems"
                :value="currentPage"
                align="right"
                aria-controls="changePage"
                @input="change_page"
            ></BPagination>
        </BCol>
    </BRow>
</template>

<script>
import { BCol, BFormSelect, BPagination, BRow } from "bootstrap-vue";
import _ from "lodash";

export default {
    name: "OListPaging",
    components: {
        BRow,
        BCol,
        BFormSelect,
        BPagination,
    },
    props: {
        limit: { type: Number, default: 0 },
        pageOptions: {
            type: Array,
            default() {
                return [5, 10, 20, 50, 100];
            },
        },
        offset: { type: Number, default: 0 },
        totalItems: { type: Number, default: 0 },
    },
    computed: {
        limit_options() {
            return _.map(this.pageOptions || [], function (opt) {
                return { value: opt, text: opt };
            });
        },
        showingFrom() {
            return this.totalItems === 0 ? 0 : this.offset + 1;
        },
        showingTo() {
            return Math.min(this.offset + this.limit, this.totalItems);
        },
        currentPage() {
            // NOTE The first page needs to be 1.
            return (this.offset || 0) / (this.limit || 10) + 1;
        },
    },
    methods: {
        change_rowsPerPage(rowsPerPage) {
            this.$emit("change-limit", rowsPerPage);
        },
        change_page(page) {
            this.$emit("change-page", page);
        },
    },
};
</script>

<style scoped></style>
